import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style.js';
import Feature from 'ol/Feature';
import { Point } from 'ol/geom';
import 'ol/ol.css';
import * as proj from 'ol/proj';

// --- HITBOX TOLERANCE CONSTANTS ---
const ANNOTATION_HIT_TOLERANCE_PX = 8; // screen-pixel radius for annotation hit detection

var annotationsByUser;
var annotationsByGroup;
var vectorAnnotationsByUser;
var vectorAnnotationsByGroup;

var styleUserAnnotatios = new Style({
    image: new CircleStyle({
        radius: 5,
        fill: new Fill({ color: '#3399ff' }),
        stroke: new Stroke({ color: 'white', width: 2 })
    })
});

var styleGroupAnnotatios = new Style({
    image: new CircleStyle({
        radius: 5,
        fill: new Fill({ color: '#ffbb33' }),
        stroke: new Stroke({ color: 'white', width: 2 })
    })
});


export const annotations = {
    data() {
        return {
            message: "holi",
            featuresByUser: [],
            featuresByGroup: [],
            boundShowAnnotationModal: null,
            boundChangeCursor: null,
            boundSendAnnotationInfo: null
        }
    },
    methods: {
        addAnnotationInteraction: function () {
            this.removeAnnotationSelectorListener();
            document.body.style.cursor = 'crosshair';

            if (!this.boundShowAnnotationModal) {
                this.boundShowAnnotationModal = this.showAnnotationModal.bind(this);
            }
            this.map.on('singleclick', this.boundShowAnnotationModal);
        },
        showAnnotationModal: function (evt) {
            this.executeMapToolAction('annotations', 'showModal', { annotationCoor: proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326') })
        },
        removeAnnotationInteraction: function () {
            document.body.style.cursor = 'default';
            if (this.boundShowAnnotationModal) {
                this.map.un('singleclick', this.boundShowAnnotationModal);
            }
            this.addAnnotationSelectorListener();
        },
        removeAnnotationSelectorListener: function () {
            if (this.boundChangeCursor) this.map.un('pointermove', this.boundChangeCursor);
            if (this.boundSendAnnotationInfo) this.map.un('singleclick', this.boundSendAnnotationInfo);
        },
        addAnnotationSelectorListener: function () {
            if (!this.boundSendAnnotationInfo) this.boundSendAnnotationInfo = this.sendAnnotationInfo.bind(this);
            if (!this.boundChangeCursor) this.boundChangeCursor = this.changeCursor.bind(this);

            this.map.on('singleclick', this.boundSendAnnotationInfo);
            this.map.on('pointermove', this.boundChangeCursor);
        },
        changeCursor: function (evt) {
            var feature = this.map.forEachFeatureAtPixel(evt.pixel,
                function (feature) {
                    return feature;
                }, { hitTolerance: ANNOTATION_HIT_TOLERANCE_PX });
            if (feature) document.body.style.cursor = 'pointer'
            else document.body.style.cursor = 'default'
        },
        sendAnnotationInfo: function (evt) {
            var feature = this.map.forEachFeatureAtPixel(evt.pixel,
                function (feature) {
                    return feature;
                }, { hitTolerance: ANNOTATION_HIT_TOLERANCE_PX });

            var annotationInfo = {
                id: "",
                text: "",
                user: "",
                shared: "",
                map: "",
                group: "",
                coordinates: [],
            }
            if (feature) {
                document.body.style.cursor = 'default'
                annotationInfo.id = feature.get('id')
                annotationInfo.text = feature.get('text')
                annotationInfo.shared = feature.get('shared')
                annotationInfo.map = feature.get('map')
                annotationInfo.group = feature.get('group')
                annotationInfo.coordinates = feature.get('coordinates')
                if (feature.get('user')) {
                    annotationInfo.user = feature.get('user')
                    this.executeMapToolAction('annotations', 'showAnnotationInfo', { info: annotationInfo })
                }
                else {
                    this.executeMapToolAction('annotations', 'showAnnotationInfo', { info: annotationInfo })
                }
            }
        },
        getFeaturesByUser: function (array) {
            annotationsByUser = array
            this.featuresByUser = new Array(annotationsByUser.length);
            for (var i = 0; i < annotationsByUser.length; ++i) {
                this.featuresByUser[i] = new Feature({
                    'geometry': new Point(proj.fromLonLat(annotationsByUser[i].location.coordinates)),
                    'id': annotationsByUser[i].id,
                    'text': annotationsByUser[i].text,
                    'map': annotationsByUser[i].id_map,
                    'group': annotationsByUser[i].id_group,
                    'coordinates': annotationsByUser[i].location.coordinates,
                    'shared': annotationsByUser[i].is_shared
                });
            }
        },
        createAnnatotionsByUserLayer: function (features) {
            vectorAnnotationsByUser = new VectorLayer({
                source: new VectorSource({
                    features: features,
                }),
                style: function () {
                    return styleUserAnnotatios;
                }
            });
            this.map.addLayer(vectorAnnotationsByUser);

        },
        removeAnnotationsByUserLayer: function () {
            this.map.removeLayer(vectorAnnotationsByUser)
            vectorAnnotationsByUser = null
        },
        getFeaturesByGroup: function (array, user) {
            annotationsByGroup = array
            this.featuresByGroup = new Array(annotationsByGroup.length);
            for (var i = 0; i < annotationsByGroup.length; ++i) {
                if (annotationsByGroup[i].id_user != user) {
                    this.featuresByGroup[i] = new Feature({
                        'geometry': new Point(proj.fromLonLat(annotationsByGroup[i].location.coordinates)),
                        'id': annotationsByGroup[i].id,
                        'text': annotationsByGroup[i].text,
                        'map': annotationsByGroup[i].id_map,
                        'group': annotationsByGroup[i].id_group,
                        'coordinates': annotationsByGroup[i].location.coordinates,
                        'user': annotationsByGroup[i].id_user,
                        'shared': annotationsByGroup[i].is_shared
                    })
                }
            }
        },
        createAnnotationsByGroupLayer: function (features) {
            vectorAnnotationsByGroup = new VectorLayer({
                source: new VectorSource({
                    features: features,
                }),
                style: function () {
                    return styleGroupAnnotatios;
                }
            });
            this.map.addLayer(vectorAnnotationsByGroup)
        },
        removeAnnotationsByGroupLayer: function () {
            this.map.removeLayer(vectorAnnotationsByGroup)
            vectorAnnotationsByGroup = null
        }
    },
    watch: {
        'featuresByUser': function (value) {
            this.createAnnatotionsByUserLayer(value)
        },
        'featuresByGroup': function (value) {
            var filtered = value.filter(function (el) {
                return el != null;
            });
            this.createAnnotationsByGroupLayer(filtered)
        }
    },
}